"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useThrottler = require("./useThrottler.cjs");
function useThrottledCallback(fn, options) {
  const throttledFn = useThrottler.useThrottler(fn, options).maybeExecute;
  return react.useCallback((...args) => throttledFn(...args), [throttledFn]);
}
exports.useThrottledCallback = useThrottledCallback;
//# sourceMappingURL=useThrottledCallback.cjs.map
